import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { CONSTANTS_ROUTING } from './common/constants/routing/routing.constants';
import { CAMPAIGN } from './components/campaign/campaign.constants';
import { ExactCampaignResolver } from './components/campaign/exact-campaign.resolver';
import { CONTACT_GUEST_CONSTANTS } from './components/contact-guest/contact-guest.constants';
import { DEMOGRAPHICS_CONSTANTS } from './components/demographics/demographics.constants';
import { FLEXIBLE_PORTAL_CONSTANTS } from './components/flexible-portal/flexible-portal.constants';
import { ONE_MORE_QUESTION_CONSTANTS } from './components/one-more-question/one-more-question.constants';
import { VOUCHER_ROUTING_CONSTANTS } from './components/voucher/voucher-routing.constant';
import { WHEEL_OF_FORTUNE_ROUTING_CONSTANTS } from './components/wheel-of-fortune/wheel-of-fortune-routing.constants';

export const routes: Routes = [
  // Dev-only local harnesses; excluded from production builds.
  ...(environment.production
    ? []
    : [
        {
          path: 'wheel-sandbox',
          loadComponent: () =>
            import('./components/wheel-of-fortune/wheel-of-fortune-spin/wheel-sandbox.component').then(
              m => m.WheelSandboxComponent
            ),
        },
        {
          path: 'dev-sandbox',
          loadComponent: () =>
            import('./components/dev-sandbox/dev-sandbox.component').then(
              m => m.DevSandboxComponent
            ),
        },
      ]),
  {
    path: '',
    loadComponent: () =>
      import('./components/layout/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: CONSTANTS_ROUTING.ROUTES.SURVEY,
        loadChildren: () =>
          import('./components/survey/survey.routes').then(module => module.SURVEY_ROUTES),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.VENUES,
        loadChildren: () =>
          import('./components/venues/venues.routes').then(module => module.VENUES_ROUTES),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.CLOSED,
        loadChildren: () =>
          import('./components/closed-page/closed-page.routes').then(
            module => module.CLOSED_PAGE_ROUTES
          ),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.NOT_FOUND,
        loadChildren: () =>
          import('./components/not-found-page/not-found-page.routes').then(
            module => module.NOT_FOUND_PAGE_ROUTES
          ),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.GHOST,
        loadChildren: () =>
          import('./components/not-found-page/not-found-page.routes').then(
            module => module.NOT_FOUND_PAGE_ROUTES
          ),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.ADD.MAIN,
        loadChildren: () =>
          import('./components/ad-pages/ad-pages.routes').then(module => module.AD_PAGES_ROUTES),
      },
      {
        path: WHEEL_OF_FORTUNE_ROUTING_CONSTANTS.ROUTES.HAPPY_WHEEL.MAIN,
        loadChildren: () =>
          import('./components/wheel-of-fortune/wheel-of-fortune.routes').then(
            module => module.WHEEL_OF_FORTUNE_ROUTES
          ),
      },
      {
        path: VOUCHER_ROUTING_CONSTANTS.ROUTES.VOUCHER,
        loadChildren: () =>
          import('./components/voucher/voucher.routes').then(module => module.VOUCHER_ROUTES),
      },
      {
        path: CONTACT_GUEST_CONSTANTS.ROUTES.MAIN,
        loadChildren: () =>
          import('./components/contact-guest/contact-guest.routes').then(
            module => module.CONTACT_GUEST_ROUTES
          ),
      },
      {
        path: DEMOGRAPHICS_CONSTANTS.ROUTES.MAIN,
        loadChildren: () =>
          import('./components/demographics/demograhics.routes').then(
            module => module.DEMOGRAPHICS_ROUTES
          ),
      },
      {
        path: FLEXIBLE_PORTAL_CONSTANTS.ROUTES.MAIN,
        loadChildren: () =>
          import('./components/flexible-portal/flexible-portal.routes').then(
            module => module.FLEXIBLE_PORTAL_ROUTES
          ),
      },
      {
        path: ONE_MORE_QUESTION_CONSTANTS.ROUTES.FORM,
        loadChildren: () =>
          import('./components/one-more-question/one-more-question.routes').then(
            module => module.ONE_MORE_QUESTION_ROUTES
          ),
      },
      {
        path: CAMPAIGN.ROUTES.CAMP_FORM,
        loadComponent: () =>
          import('./components/campaign/campaign.component').then(m => m.CampaignComponent),
        resolve: {
          response: ExactCampaignResolver,
        },
      },
      {
        path: CAMPAIGN.ROUTES.FORM,
        loadChildren: () =>
          import('./components/campaign/campaign.routes').then(module => module.CAMPAIGN_ROUTES),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.VENUE_DISABLED,
        loadChildren: () =>
          import('./components/venue-disabled-page/venue-disabled-page.routes').then(
            module => module.VENUE_DISABLED_PAGE_ROUTES
          ),
      },
      {
        path: CONSTANTS_ROUTING.ROUTES.ERROR,
        loadChildren: () =>
          import('./components/error-pages/error-pages.routes').then(
            module => module.ERROR_PAGES_ROUTES
          ),
      },
      {
        path: '**',
        loadChildren: () =>
          import('./components/empty-page/empty-page.routes').then(
            module => module.EMPTY_PAGE_ROUTES
          ),
      },
    ],
  },
];
